import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
  Label,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import Select from "react-select";

// actions
import {
  resetProfiles,
  resetError,
  getProfilesBackoffice,
  getProfilesClient,
  deleteProfile,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const Profiles = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const backOfficeLabel = (
    <span key={0} className="text-warning">
      BACKOFFICE
    </span>
  );

  const {
    dataProfile,
    dataProfileDelete,
    loadingProfile,
    loadingProfileDelete,
    errorProfile,
    successProfile,
  } = useSelector((state) => state.Profile);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [profileId, setProfileId] = useState("");
  const [profileName, setProfileName] = useState("");

  const [nameFilter, setNameFilter] = useState("");
  const [descriptionFilter, setDescriptionFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [companyId, setCompanyId] = useState();

  const [departmentId, setDepartmentId] = useState();

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successProfile && dispatch(resetProfiles()) && handleFilter(),
  };

  const handleFilter = (name, description) => {
    setNameFilter(name);
    setDescriptionFilter(description);
    setPage(1);
    if (companyId) {
      dispatch(
        getProfilesClient(companyId, 1, qtdDefault, name, description, true)
      );
    } else {
      dispatch(getProfilesBackoffice(1, qtdDefault, name, description, true));
    }
  };

  const handleDelete = () => {
    if (companyId) {
      dispatch(deleteProfile(profileId, companyId, departmentId));
    } else {
      dispatch(deleteProfile(profileId));
    }
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setProfileIdName = (profile) => {
    setProfileId(profile.id);
    setProfileName(profile.name);
  };

  const handlePage = (value) => {
    setPage(value);
    if (companyId) {
      dispatch(
        getProfilesClient(
          companyId,
          value,
          qtdDefault,
          nameFilter,
          descriptionFilter,
          true
        )
      );
    } else {
      dispatch(
        getProfilesBackoffice(
          value,
          qtdDefault,
          nameFilter,
          descriptionFilter,
          true
        )
      );
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataProfile && dataProfile.paging) {
      if (page < dataProfile.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const optionsCompany = () => {
    let companies = [
      {
        value: undefined,
        label: backOfficeLabel,
      },
    ];

    dataProfile?.formValues?.clients &&
      dataProfile.formValues.clients.forEach((company, key) =>
        companies.push({ key: key, value: company.id, label: company.name })
      );

    return companies;
  };

  useEffect(() => {
    dispatch(getProfilesClient(null, null, null, null, null, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataProfileDelete && dataProfileDelete.message) {
      showToast("success", t(dataProfileDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successProfile]);

  useEffect(() => {
    if (errorProfile && typeof errorProfile === "object") {
      errorProfile.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorProfile) {
        showToast("error", t(errorProfile));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorProfile]);

  useEffect(() => {
    if (dataProfile && dataProfile.idCompany) {
      setCompanyId(dataProfile.idCompany);
    }
    if (dataProfile !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataProfile]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/profiles"
            title={t("Dashboard")}
            breadcrumbItem={t("Profiles")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name, values.description);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Description")}
                            id="description"
                            name="description"
                            type="text"
                            className="form-control"
                            placeholder={t("Description") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Description must be composed only with letter and space"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <Label className="control-label">
                            {t("Company")}
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            className="w-100 mb-3"
                            options={optionsCompany()}
                            isLoading={loadingProfile ? true : false}
                            isSearchable
                            onChange={(e) => {
                              setCompanyId(e.value);
                            }}
                            noOptionsMessage={() =>
                              t("Click search to show the records")
                            }
                            value={optionsCompany().find(
                              (item) => item.value === companyId
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-profile">
                          <Link
                            to={
                              companyId
                                ? `/company/${companyId}/profile`
                                : `/profile`
                            }
                          >
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Profile")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Permission type")}</th>
                            <th>{t("Description")}</th>
                            {companyId && <th>{t("Department")}</th>}
                            <th>{t("Nº of users")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingProfile ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataProfile &&
                            dataProfile.profiles &&
                            dataProfile.profiles.length > 0 ? (
                            dataProfile.profiles.map((profile, key) => (
                              <tr key={key}>
                                <td>{profile.name}</td>
                                {companyId ? (
                                  <td>
                                    {profile.role && profile.role.description}
                                  </td>
                                ) : (
                                  <td>
                                    {profile.roles && profile.roles.description}
                                  </td>
                                )}
                                <td>
                                  {profile.description &&
                                  profile.description.length > 50
                                    ? profile.description.substring(0, 50) +
                                      "..."
                                    : profile.description}
                                </td>
                                {companyId && (
                                  <td>
                                    {profile.department &&
                                      profile.department.name}
                                  </td>
                                )}
                                <td>{profile.count}</td>
                                <td>
                                  <Link
                                    to={
                                      companyId
                                        ? `/company/${companyId}/profile/${profile.id}`
                                        : `/profile/${profile.id}`
                                    }
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="edittooltip"
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  {/* TODO: add custom styles to css file */}
                                  <span style={{ cursor: "pointer" }}>
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id="deletetooltip"
                                      onClick={() => {
                                        toggleModal();
                                        setProfileIdName(profile);
                                        setDepartmentId(profile.department_id);
                                      }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="deletetooltip"
                                    >
                                      {t("Delete")}
                                    </UncontrolledTooltip>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingProfileDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the profile")}
                          <strong> {profileName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingProfileDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (profileId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataProfile &&
                  dataProfile.paging &&
                  dataProfile.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataProfile &&
                        dataProfile.paging &&
                        dataProfile.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Profiles);
